import React, { forwardRef } from 'react';
export function ToastComponent(StyledToast) {
    return forwardRef(({ children, ...props }, ref) => {
        return (<StyledToast {...props} ref={ref}>
        {children}
      </StyledToast>);
    });
}
